/**
 * @generated SignedSource<<17903dcde225a6ed7384edc3cb680052>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskDemoDialog_task$data = {
  readonly uuid: string;
  readonly " $fragmentType": "TaskDemoDialog_task";
};
export type TaskDemoDialog_task$key = {
  readonly " $data"?: TaskDemoDialog_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskDemoDialog_task">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskDemoDialog_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node as any).hash = "414f5ad3e14e2d3f9d04945164f6f097";

export default node;
